import { render, staticRenderFns } from "./FlexibleCarousel1.vue?vue&type=template&id=4eecac7a&scoped=true"
import script from "./FlexibleCarousel1.vue?vue&type=script&lang=ts"
export * from "./FlexibleCarousel1.vue?vue&type=script&lang=ts"
import style0 from "./FlexibleCarousel1.vue?vue&type=style&index=0&id=4eecac7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eecac7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VIcon,VImg})
